import request from "root/js/request";

export const getExpenseGroupsCrossMP = async ({ cabinet_id, ...rest }) => {
  const response = await request({
    url: "/analytics/cross-mp/expense/group/",
    method: "get",
    params: {
      cabinet_id,
      ...rest,
    },
  });
  return response.data;
};

export const postCreateExpenseGroupCrossMP = async ({
  cabinet_id,
  name,
  expense_type,
  group_type,
  category,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/cross-mp/expense/group/",
    method: "post",
    params: {
      cabinet_id,
    },
    data: {
      name,
      expense_type,
      group_type,
      category,
      ...rest,
    },
  });
  return response;
};

export const putEditExpenseGroupCrossMPById = async ({
  cabinet_id,
  group_id,
  name,
  expense_type,
  group_type,
  category,
  ...rest
}) => {
  const response = await request({
    url: `/analytics/cross-mp/expense/group/${group_id}/`,
    method: "put",
    params: {
      cabinet_id,
    },
    data: {
      name,
      expense_type,
      group_type,
      category,
      ...rest,
    },
  });
  return response;
};

export const deleteExpenseGroupCrossMPById = async ({ cabinet_id, group_id, ...rest }) => {
  const response = await request({
    url: `/analytics/cross-mp/expense/group/${group_id}/`,
    method: "delete",
    params: {
      cabinet_id,
      ...rest,
    },
  });
  return response;
};
